<template>
  <div class="login-container">
    <el-card class="login-card">
      <h2 class="login-title">系统登录</h2>
      <el-form ref="loginForm" :model="model" :rules="validatorRules" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="model.username" @keyup.enter.native="handleSubmit" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="model.password" @keyup.enter.native="handleSubmit" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="captcha">
          <el-row :gutter="10">
            <el-col :span="14">
              <el-input v-model="model.inputCode" @keyup.enter.native="handleSubmit" placeholder="请输入验证码"></el-input>
            </el-col>
            <el-col :span="10" style="text-align: right">
              <img v-if="requestCodeSuccess" style="margin-top: 2px;" :src="randCodeImage"
                   @click="handleChangeCheckCode"/>
              <img v-else style="margin-top: 2px;" src="../assets/checkcode.png" @click="handleChangeCheckCode"/>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button size="large" type="primary" :loading="loginBtn"
                     @click.stop.prevent="handleSubmit" :disabled="loginBtn">登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {service} from '../utils/axios'
import Vue from 'vue'
import { USER_NAME } from '@/store/mutation-types'
import {setToken} from '../utils/auth'

export default {
  name: 'Login',
  data () {
    return {
      rememberMe: true,
      loginBtn: false,
      requestCodeSuccess: false,
      randCodeImage: '',
      loginType: 0,
      model: {
        username: '',
        password: '',
        inputCode: ''
      },
      validatorRules: {
        username: [
          {required: true, message: '请输入用户名!'},
          {validator: this.handleUsernameOrEmail}
        ],
        password: [{
          required: true, message: '请输入密码!', validator: 'click'
        }],
        inputCode: [{
          required: true, message: '请输入验证码!'
        }]
      },
      captchaCode: ''
    }
  },
  created () {
    this.handleChangeCheckCode()
  },
  methods: {
    /** 刷新验证码 */
    handleChangeCheckCode () {
      this.currdatetime = new Date().getTime()
      this.model.inputCode = ''
      service.get(`/sys/randomImage/${this.currdatetime}`).then(res => {
        if (res.success) {
          this.randCodeImage = res.result
          this.requestCodeSuccess = true
        } else {
          this.$message.error(res.message)
          this.requestCodeSuccess = false
        }
      }).catch(() => {
        this.requestCodeSuccess = false
      })
    },
    // 判断登录类型
    handleUsernameOrEmail (rule, value, callback) {
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        this.loginType = 0
      } else {
        this.loginType = 1
      }
      callback()
    },
    // 登录
    handleSubmit () {
      this.loginBtn = true
      // 使用账户密码登录
      this.handleLogin(this.rememberMe)
    },
    // 账号密码登录
    handleLogin (rememberMe) {
      let loginParams = {
        username: this.model.username,
        password: this.model.password,
        captcha: this.model.inputCode,
        checkKey: this.currdatetime,
        remember_me: rememberMe
      }
      console.log('登录参数', loginParams)
      this.Login(loginParams).then((res) => {
        this.$emit('success', res.result)
      }).catch((err) => {
        // update-begin-author: taoyan date:20220425 for: 登录页面，当输入验证码错误时，验证码图片要刷新一下，而不是保持旧的验证码图片不变 #41
        if (err && err.code === 412) {
          this.handleChangeCheckCode()
        }
        // update-end-author: taoyan date:20220425 for: 登录页面，当输入验证码错误时，验证码图片要刷新一下，而不是保持旧的验证码图片不变 #41
        this.$emit('fail', err)
      })
    },
    // 登录
    Login (userInfo) {
      console.log('登录参数', userInfo)
      return new Promise(async (resolve, reject) => {
        const response = await service.post('/sys/login', userInfo)
        console.log(response)
        if (response.code === 200) {
          const result = response.result
          const userInfo = result.userInfo
          setToken(result.token)
          Vue.ls.set(USER_NAME, userInfo.username, 7 * 24 * 60 * 60 * 1000)
          // Vue.ls.set(USER_INFO, userInfo, 7 * 24 * 60 * 60 * 1000)
          // Vue.ls.set(UI_CACHE_DB_DICT_DATA, result.sysAllDictItems, 7 * 24 * 60 * 60 * 1000)
          // commit('SET_TOKEN', result.token)
          // commit('SET_INFO', userInfo)
          // commit('SET_NAME', {username: userInfo.username, realname: userInfo.realname})
          // commit('SET_AVATAR', userInfo.avatar)

          this.$router.push({
            path: '/SidebarMenu/anDeEICOrderList',
            query: { saleId: this.$route.query.saleId }
          }).then(() => {
            console.log('路由跳转成功')
          }).catch(err => {
            console.error('路由跳转失败:', err)
          })

          this.loginBtn = false
          this.$message.success(response.message)
          resolve(response)
        } else {
          this.loginBtn = false
          this.$message.error(response.message)
          reject(response)
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.login-card {
  width: 400px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.login-title {
  text-align: center;
  margin-bottom: 20px;
  color: #1890ff;
}

.captcha-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  background-color: #f5f5f5;
  border-radius: 4px;
  cursor: pointer;
}

.captcha-char {
  margin: 0 5px;
  font-size: 20px;
  font-weight: bold;
  color: #1890ff;
  transform: rotate(-5deg);
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue